<template>
    <div>
        <NavBar />
        
        <div class="container mx-auto">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="px-4 py-6 sm:px-0 mt-32">
                    <div class="flex flex-wrap">
                        <div class="w-full md:w-1/2">
                            <img
                                class="mx-auto"
                                src="../assets/images/dashboard_img/congrts.png"
                                alt="campaign sent image"
                            >
                        </div>
                        <div class="w-full md:w-1/2">
                            <p class="text-5xl font-bold tracking-tight text-green">Congratulations!</p>
                            <p class="text-3xl font-medium text-green">Your campaign has been sent</p>
                            <p class="text-2xl font-bold text-blue-800">Your job no is: <label> {{ jobId }} </label> </p>

                            <router-link
                                to="/message_type"
                                class="bg-green-500 hover:bg-green-700 text-white font-bold text-sm py-3 px-4 mt-2 inline-block rounded"
                            >
                                Return to Dashboard
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    body {
        background: #fff;
    }
</style>

<script>
import { mapGetters } from "vuex";
import NavBar from "../components/NavBar";

export default {
    name: "Congratulations",
    components: {
        NavBar,
    },
    computed: {
        ...mapGetters([
            "jobId"
        ]),
    }
}
</script>